import { BankOutlined, CreditCardOutlined } from "@ant-design/icons";

type ProviderIconProps = {
  type: number;
};

export const ProviderIcon = ({ type }: ProviderIconProps) => {
  switch (type) {
    case 1:
      return <BankOutlined className="provider-icon" />;
    case 2:
      return <CreditCardOutlined className="provider-icon" />;
    default:
      return null;
  }
};
